import type { Operation } from '@trpc/client'
import { Platform } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import AppConfig from 'config'
import { getAppRegion } from 'storage/useRemoteConfigParams'

export type NonEmptyArray<T> = [T, ...T[]]

export type SessionTokens = {
  customer?: string
  staff?: string
  store?: string
}

export const NO_AUTH_OP = ['health']

const getAgentVersion = () =>
  Platform.select({
    web: navigator?.userAgent || 'web',
    default: `${DeviceInfo.getVersion()}/${DeviceInfo.getBuildNumber()} ${DeviceInfo.getSystemName()}/${DeviceInfo.getSystemVersion()}`,
  })

export const isTokenRefreshOperation = (op: Operation) =>
  op.path === 'refreshToken'

/** Ops that neither need auth headers nor need to refresh the session. */
export const skipsTokenRefresh = (opList: NonEmptyArray<Operation>) =>
  opList.every((op) => NO_AUTH_OP.includes(op.path))

export function buildRequestHeaders(
  tokens: SessionTokens,
  opts?: { opList: NonEmptyArray<Operation> }
) {
  const res: Record<string, string> = {
    'x-ca-app': `${AppConfig.app.version}/${
      AppConfig.app.hash
    } ${getAgentVersion()}`,
    'x-ca-region': getAppRegion().code,
  }

  // Auth-free batches must not carry session headers.
  if (opts && skipsTokenRefresh(opts.opList)) {
    return res
  }

  if (tokens.customer) {
    res['x-customer'] = `Bearer ${tokens.customer}`
  }
  if (tokens.staff) {
    res['x-staff'] = `Bearer ${tokens.staff}`
  }
  if (tokens.store) {
    res['x-store'] = `Bearer ${tokens.store}`
  }

  return res
}
